export enum DefaultItemList {
    DEFAULT_NUMBER_OF_ITEMS = 5
  }

export enum IconToggleType {
    STATUS = 'STATUS',
    HAZMATLOAD = 'HAZMATLOAD',
    TOGGLE = 'TOGGLE'
}
